export const getInitialMosaicValues = date => ({
  type: 'MOSAIC',
  status: 'draft',
  startDate: date,
  endDate: date,
  actions: [
    {
      failure: [],
      success: [
        {
          type: 'Send Tweet',
          action: 'SEND_TWEET',
          message: '',
          isPromotedTweet: true,
          isMosaicConsent: true
        }
      ],
      platform: 'twitter',
      triggers: [
        {
          type: 'Like',
          action: 'NEW_TWEET',
          RetweetUrl: ''
        }
      ],
      description: 'Send Mosaic Opt In Consent',
      operator: 'all'
    },
    {
      failure: [],
      success: [
        {
          type: 'Add to mosaic'
        }
      ],
      platform: 'twitter',
      triggers: [
        {
          type: 'Like',
          action: 'EXISTING_TWEET',
          value: '00000'
        }
      ],
      description: 'Mosaic opt in',
      operator: 'all'
    },
    {
      failure: [],
      success: [
        {
          type: 'Mosaic opt out'
        }
      ],
      platform: 'twitter',
      triggers: [
        {
          type: 'Match hashtag',
          value: ['#optout']
        },
        {
          type: 'Match handle',
          value: []
        }
      ],
      description: 'Mosaic opt out',
      operator: 'all'
    }
  ],
  mosaic: {
    duplicatesAllowed: true,
    duplication: 20
  },
  moderated: true,
  moderators: { handles: [] },
  automated: false,
  threshold: 0,
  enableFiltering: true,
  enableBlastFiltering: true,
  store: false,
  profanity: false,
  lock: false
})



// WEBPACK FOOTER //
// ./src/pages/widgets/mosaic/create/container/initialValues.js